import { z } from 'zod'

import { walletSchema } from '@/features/veluvit/schemas/wallet.schema'

const questTrackSchema = z.enum(['character', 'world', 'command', 'status'])
const creatorQuestItemSchema = z.looseObject({
  id: z.string(),
  title: z.string(),
  kind: z.enum(['quest', 'achievement']),
  target: z.number().int().positive(),
  progress: z.number().int().nonnegative(),
  reward: z.object({
    gem: z.number().int().nonnegative().optional(),
    tickets: z.number().int().nonnegative().optional(),
    expiresInDays: z.number().int().optional(),
  }),
  definitionVersion: z.number().int(),
  order: z.number().int(),
  track: questTrackSchema.optional(),
  location: z.string().optional(),
  completed: z.boolean(),
  claimed: z.boolean(),
  current: z.boolean(),
  claimable: z.boolean(),
  targetId: z.string().nullable(),
})
const active = z.looseObject({
  enabled: z.literal(true),
  schemaVersion: z.literal(2),
  version: z.number().int(),
  rewardPolicy: z.record(z.string(), z.unknown()),
  items: z.array(creatorQuestItemSchema),
  tracks: z.array(
    z.object({
      id: questTrackSchema,
      targetId: z.string().nullable(),
      targetAvailable: z.boolean(),
      targetLocked: z.boolean(),
      currentStepId: z.string().nullable(),
      claimedSteps: z.number().int(),
      stepCount: z.number().int(),
      complete: z.boolean(),
    })
  ),
  claimedIds: z.array(z.string()),
  activeDefinitionCount: z.number().int(),
})
export const creatorQuestSchema = z.discriminatedUnion('enabled', [
  z.object({
    enabled: z.literal(false),
    version: z.number().int(),
    items: z.array(z.unknown()),
  }),
  active,
])
export const creatorQuestClaimSchema = active.extend({
  grantedIds: z.array(z.string()),
  requestId: z.string(),
  replayed: z.boolean(),
  wallet: walletSchema,
})
export type CreatorQuest = z.infer<typeof creatorQuestSchema>
export type CreatorQuestItem = z.infer<typeof creatorQuestItemSchema>
